import script from "./ManagePayment.vue?vue&type=script&setup=true&lang=ts"
export * from "./ManagePayment.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__